import {
  FormGroup,
  FormControl,
  FormBuilder,
  NonNullableFormBuilder,
  Validators,
  ValidationErrors,
} from '@angular/forms';
import { validPublishNameValidator } from '@mode/dataset/ui';

export interface PublishDatasetFormData {
  name: string;
  schema?: string;
}

type Form<TData> = Required<{
  [K in keyof TData]: FormControl<TData[K]>;
}>;

export class PublishDatasetForm extends FormGroup<Form<PublishDatasetFormData>> {
  readonly name = this.controls.name;
  readonly schema = this.controls.schema;

  get nameErrors() {
    return this.name.touched && this.name.errors;
  }
  constructor(readonly fb: NonNullableFormBuilder = new FormBuilder().nonNullable) {
    super(
      fb.group<Form<PublishDatasetFormData>>({
        name: fb.control('', { validators: [validPublishNameValidator, Validators.required] }),
        schema: fb.control({ value: '', disabled: true }),
      }).controls
    );
  }

  updateSchema(schema: string) {
    this.patchValue({ schema });
    this.schema.markAsTouched();
    this.schema.updateValueAndValidity();
  }

  updateName(name: string) {
    this.patchValue({ name });
    this.name.markAsTouched();
    this.name.updateValueAndValidity();
  }

  errorKeys(errors: ValidationErrors): string[] {
    return Object.keys(errors).filter((key) => key !== 'required');
  }
}
